import { render, staticRenderFns } from "./CircleVideo.vue?vue&type=template&id=63ad0f2c&scoped=true&"
import script from "./CircleVideo.vue?vue&type=script&lang=js&"
export * from "./CircleVideo.vue?vue&type=script&lang=js&"
import style0 from "./CircleVideo.vue?vue&type=style&index=0&id=63ad0f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad0f2c",
  null
  
)

export default component.exports